import React from 'react'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Box,
  Button as MUIButton
} from '@material-ui/core'
import Button from 'src/components/ui/Button'
import { DadosPropostaHistorico } from 'src/types'
import StatusProposta from 'src/core/consts/statusProposta'
import formatarDinheiro from 'src/core/formatacoes/formatarDinheiro'

export interface ModalConfirmarAprovacaoLoteProps {
  open: boolean
  onClose: () => void
  onConfirm: () => void
  loading: boolean
  propostas: DadosPropostaHistorico[]
}

export const ModalConfirmarAprovacaoLote: React.FC<ModalConfirmarAprovacaoLoteProps> = ({
  open,
  onClose,
  onConfirm,
  loading,
  propostas
}) => {
  const propostasPendentes = (propostas || []).filter(
    p => p.status === StatusProposta.AGUARDANDO_APROVACAO_MEDICO.Id
  )
  const total = propostasPendentes.length

  return (
    <Dialog
      open={open}
      onClose={loading ? undefined : onClose}
      maxWidth="sm"
      fullWidth
      aria-labelledby="modal-aprovacao-lote-titulo"
    >
      <DialogTitle id="modal-aprovacao-lote-titulo">
        Aprovar todas as propostas pendentes
      </DialogTitle>
      <DialogContent dividers>
        <Typography variant="body1" gutterBottom>
          Você está prestes a aprovar{' '}
          <strong>
            {total} {total === 1 ? 'proposta pendente' : 'propostas pendentes'}
          </strong>{' '}
          para envio ao paciente. Confira as propostas que serão aprovadas:
        </Typography>

        <Box maxHeight={320} overflow="auto" my={2}>
          {propostasPendentes.length === 0 ? (
            <Typography variant="body2" color="textSecondary" align="center">
              Nenhuma proposta aguardando aprovação médica.
            </Typography>
          ) : (
            propostasPendentes.map(p => (
              <Box
                key={p.id || p.codigo}
                border="1px solid #e0e0e0"
                borderRadius={8}
                p={2}
                mb={1.5}
                bgcolor="#f9fafb"
              >
                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                >
                  <Typography variant="subtitle1" style={{ fontWeight: 600 }}>
                    {p.localAtendimento || 'Hospital não informado'}
                  </Typography>
                  <Typography
                    variant="subtitle1"
                    color="primary"
                    style={{ fontWeight: 700 }}
                  >
                    {formatarDinheiro(p.valorTotal)}
                  </Typography>
                </Box>
                <Box
                  display="flex"
                  justifyContent="space-between"
                  alignItems="center"
                  mt={0.5}
                >
                  <Typography variant="body2" color="textSecondary">
                    Internação: {p.internacao || 'Não informada'}
                  </Typography>
                  <Typography variant="caption" color="textSecondary">
                    Proposta #{p.codigo}
                  </Typography>
                </Box>
              </Box>
            ))
          )}
        </Box>

        <Typography variant="body2" color="textSecondary">
          Esta ação não afetará propostas que já tenham sido recusadas anteriormente.
        </Typography>
      </DialogContent>
      <DialogActions>
        <MUIButton onClick={onClose} disabled={loading} color="default">
          Cancelar
        </MUIButton>
        <Button
          variant="contained"
          color="primary"
          onClick={onConfirm}
          loading={loading}
          disabled={loading || total === 0}
          aria-label="Confirmar aprovação"
        >
          Confirmar aprovação
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ModalConfirmarAprovacaoLote
